// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__7MOUu","fieldError":"styles_fieldError__wVc3M","fieldWarning":"styles_fieldWarning__3DBkr"};